import { BILLING_COMMAND_SETTLED_STATUSES } from "@intelligems/ig-types";

// A settled command status ends the optimistic overlay. "completed" is settled
// too, but the reducer handles it separately as a reconciling transition that
// awaits raw-snapshot confirmation, so it is excluded here. Crucially this is
// derived from the canonical settled set (not the terminal set): "failed_retryable"
// is terminal-but-not-settled — it restarts on the same command row — so it must
// NOT roll back the overlay or release the single-flight lock.
const TERMINAL_COMMAND_FAILURES = new Set<string>(
  BILLING_COMMAND_SETTLED_STATUSES.filter((status) => status !== "completed")
);

export type BillingCommandMessage = Readonly<{
  commandId: string;
  orgId: string;
  status?: string;
}>;

export const isMatchingCommandMessage = (
  command: Readonly<{ commandId: string; orgId: string }>,
  message: BillingCommandMessage
): boolean =>
  command.orgId === message.orgId && command.commandId === message.commandId;

export const isTerminalCommandFailure = (status: string | undefined): boolean =>
  status !== undefined && TERMINAL_COMMAND_FAILURES.has(status);
